/**
 * Al Yakhour LLC — abstract interlocking "AY" monogram.
 * Single-color, stroke-based, scales cleanly from favicon to hero watermark.
 * Uses currentColor so it inherits text color.
 */
export default function AYMark({ className = "", strokeWidth = 3.1 }) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Outer chevron — the "A" */}
      <path
        d="M5 43 L24 5 L43 43"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Nested "Y" */}
      <path
        d="M15 15 L24 24 L33 15"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 24 L24 39"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
